import { render } from "./AttributeOptionPicker.vue?vue&type=template&id=370ccd93&scoped=true"
import script from "./AttributeOptionPicker.vue?vue&type=script&lang=js"
export * from "./AttributeOptionPicker.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./AttributeOptionPicker.vue?vue&type=style&index=1&id=370ccd93&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370ccd93"]])

export default __exports__